<template>
    <section class="gs-leaderboards-list" aria-label="Leaderboards">
        <div class="gs-leaderboards-list__toolbar">
            <label class="gs-leaderboards-list__search">{{ $t('frontend_search') }}
                <input v-model="search" type="search" placeholder="Search leaderboards" />
            </label>
            <label>Sort by
                <select v-model="selectedOrder">
                    <option value="default">Default order</option>
                    <option value="asc">Name (A–Z)</option>
                    <option value="desc">Name (Z–A)</option>
                </select>
            </label>
            <span class="gs-leaderboards-list__count" aria-live="polite">{{ filteredLeaderboards.length }} {{ filteredLeaderboards.length === 1 ? 'leaderboard' : 'leaderboards' }}</span>
        </div>
        <div v-if="filteredLeaderboards.length" class="gs-leaderboards-list__grid">
            <article v-for="board in filteredLeaderboards" :key="board.id" class="gs-leaderboard-card">
                <header class="gs-leaderboard-card__head">
                    <span class="gs-leaderboard-card__icon" aria-hidden="true"><gs-icon name="chart" size="20" /></span>
                    <h2>{{ board.name }}</h2>
                </header>
                <dl class="gs-leaderboard-card__dates">
                    <div><dt>Starts</dt><dd>{{ board.start_timestamp || '—' }}</dd></div>
                    <div><dt>Ends</dt><dd>{{ board.end_timestamp || '—' }}</dd></div>
                </dl>
                <footer class="gs-leaderboard-card__actions">
                    <gs-button variant="outline" size="sm" :aria-label="'Edit ' + board.name" @click="EditLeaderboard(board.id)"><gs-icon name="edit" size="16" />Edit</gs-button>
                    <gs-button variant="outline" size="sm" :aria-label="'Copy link for ' + board.name" @click="copyLink(board.id)"><gs-icon name="link" size="16" />Copy link</gs-button>
                    <gs-name-select class="gs-leaderboards-list__actions" :placeholder="'More actions'" :aria-label="'More actions for ' + board.name" :actions="leaderboardActions(board.id)" size="action" />
                </footer>
            </article>
        </div>
        <div v-else class="gs-leaderboards-list__empty">
            <h2>{{ search ? 'No matching leaderboards' : 'No leaderboards yet' }}</h2>
            <p>{{ search ? 'Try a different name or clear your search.' : $t('frontend_leaderboards_you_currently') }}</p>
            <gs-button v-if="search" variant="outline" size="sm" @click="search = ''">Clear search</gs-button>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import LeaderboardWidget from '@/models/LeaderboardWidget';

export default {

    props: {
        leaderBoardData: {
            type: Array,
            required: true
        },
        EditLeaderboard: {
            type: Function,
            required: true
        },
        leaderBoardTeams: {
            type: Function,
            required: true
        },
       

    },
    data() {
        return { search: '', selectedOrder: 'default' };
    },
    computed: {
        filteredLeaderboards() {
            const query = this.search.trim().toLocaleLowerCase();
            const rows = this.leaderBoardData.filter(board => String(board.name || '').toLocaleLowerCase().includes(query));
            if (this.selectedOrder === 'default') return rows;
            const direction = this.selectedOrder === 'desc' ? -1 : 1;
            return rows.sort((a, b) => direction * String(a.name || '').localeCompare(String(b.name || '')));
        },
    },
    methods: {
        leaderboardActions(id) {
            return [
                {
                    text: this.$t('frontend_clone'),
                    callback: () => this.CloneLeaderboard(id)
                },
                {
                    text: this.$t('frontend_leaderboards_teams'),
                    callback: () => this.leaderBoardTeams(id)
                },
                {
                    text: this.$t('frontend_groovesell_disqualify_affiliates'),
                    callback: () => this.blockLleaderBoard(id)
                }
            ];
        },
        async CloneLeaderboard(leader_board_id) {
            try {
                this.$loader.start('CloneLeaderboard');
                await axios.post(`/leaderboard-widgets/${leader_board_id}`, { id: leader_board_id });
                this.$emit('refreshLeaderboardData');
            } catch (error) {
                console.error('Error cloning data:', error);
            }
            this.$loader.end('CloneLeaderboard');
        },
        // copy leader board link function
        async copyLink(id) {
            this.$loader.start('copyLink');
            this.leaderboard = await LeaderboardWidget.$find(id);
            this.$emit('update-attributes', {
                key: 'leaderboard',
                value: this.leaderboard
            });
            this.$emit('update-attributes', {
                key: 'modalLinkKey',
                value: id
            });
            this.$loader.end('copyLink');
            this.$nextTick(() => {
                this.$root.$emit('modal-open', 'copy-link-modal');
            });
        },
        async blockLleaderBoard(leaderBoardId) {
            this.$loader.start('blockLleaderBoard');
            const leaderboard = await LeaderboardWidget.$find(leaderBoardId);
            this.emitData('leaderboard', leaderboard);
            const leaderboardDateRange = {
                startDate: new Date(leaderboard.start_timestamp * 1000).toISOString(),
                endDate: new Date(leaderboard.end_timestamp * 1000).toISOString(),
            };
            this.emitData('leaderboardDateRange', leaderboardDateRange);
            const arr = [];
            leaderboard.blocked_affiliates.map((value) => {
                arr.push(value.id);
            });

            const blockAffFinalArr = leaderboard.blocked_affiliates;
            this.emitData('blockAffFinalArr', blockAffFinalArr);
            this.emitData('suggestionSelectedAffiliates_block_aff', arr);
            this.emitData('selectedAffiliateBlockedIdArr', arr);
            this.$root.$emit('modal-open', 'block-leaderboard-affiliates');
            this.$loader.end('blockLleaderBoard');
        },
        emitData(key, value) {
            this.$emit('update-attributes', {
                key: key,
                value: value
            });
        }

    }
}
</script>
<style scoped>
.gs-leaderboards-list { min-width: 0; }
.gs-leaderboards-list__toolbar { display: flex; align-items: flex-end; flex-wrap: wrap; gap: 16px; margin: 24px 0 20px; }
.gs-leaderboards-list__toolbar label { display: flex; flex-direction: column; gap: 6px; font-size: 12px; font-weight: 600; color: var(--gs-muted-foreground); }
.gs-leaderboards-list__search { flex: 1; min-width: 180px; max-width: 440px; }
.gs-leaderboards-list__toolbar input, .gs-leaderboards-list__toolbar select { width: 100%; min-height: 44px; padding: 10px 12px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-md); background: var(--gs-surface); color: var(--gs-foreground); font: inherit; font-size: 14px; }
.gs-leaderboards-list__toolbar input:focus-visible, .gs-leaderboards-list__toolbar select:focus-visible { outline: 2px solid var(--gs-primary); outline-offset: 2px; }
.gs-leaderboards-list__count { margin-left: auto; padding-bottom: 12px; color: var(--gs-muted-foreground); font-size: 13px; }
.gs-leaderboards-list__grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; }
.gs-leaderboard-card { display: flex; flex-direction: column; min-width: 0; gap: 20px; padding: 24px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface); box-shadow: var(--gs-shadow-sm); }
.gs-leaderboard-card__head { display: flex; align-items: flex-start; gap: 12px; }
.gs-leaderboard-card__icon { display: flex; flex: none; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 12px; color: var(--gs-primary); background: var(--gs-primary-soft, #fff0f6); }
.gs-leaderboard-card h2 { margin: 2px 0 0; color: var(--gs-foreground); font-size: 16px; line-height: 1.45; font-weight: 700; overflow-wrap: anywhere; }
.gs-leaderboard-card__dates { display: grid; gap: 14px; margin: 0; padding: 16px; border-radius: var(--gs-radius-md); background: var(--gs-surface-subtle); }
.gs-leaderboard-card__dates dt { margin-bottom: 4px; color: var(--gs-muted-foreground); font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; }
.gs-leaderboard-card__dates dd { margin: 0; font-size: 13px; font-weight: 600; overflow-wrap: anywhere; }
.gs-leaderboard-card__actions { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-top: auto; }
.gs-leaderboards-list__actions { min-width: 170px; flex: 1; }
.gs-leaderboards-list__actions ::v-deep .cursor-pointer { min-height: 44px; }
.gs-leaderboards-list__actions ::v-deep .text-grey-500 { color: var(--gs-foreground) !important; }
.gs-leaderboards-list__actions ::v-deep .custom-scrollbars > .cursor-pointer { white-space: normal; overflow-wrap: anywhere; }
.gs-leaderboards-list__actions:focus-within { outline: 2px solid var(--gs-primary); outline-offset: 2px; border-radius: 8px; }
.gs-leaderboards-list__empty { padding: 48px 24px; border: 1px dashed var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface); text-align: center; }
.gs-leaderboards-list__empty h2 { margin: 0 0 8px; font-size: 18px; font-weight: 700; }
.gs-leaderboards-list__empty p { margin: 0 0 16px; color: var(--gs-muted-foreground); }
@media (max-width: 1100px) { .gs-leaderboards-list__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 700px) { .gs-leaderboards-list__grid { grid-template-columns: minmax(0, 1fr); } .gs-leaderboard-card { padding: 20px; } .gs-leaderboards-list__search { max-width: none; flex-basis: 100%; } }
</style>
